import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

export const getCuisineAPI = (
  search: any,
  page: any,
  limit: any,
  selectedStatus: any,
  sortField: any,
  sortDirection: any,
  role: any
) => {
  return Http.get(
    `cuisine?page=${page}&limit=${limit}&sort_by=${sortField}&sort_direction=${sortDirection}&search=${search}`
  );
};

export const addCuisineAPI = (data: any) => {
  return Http.post(ApiRoutes.addCuisine, data);
};

export const getCuisineDetailsAPI = (id: any) => {
  return Http.get(`cuisine/${id}`);
};
export const editCuisineAPI = (id: any, data: any) => {
  return Http.put(`cuisine/${id}`, data);
};
export const deleteCuisineAPI = (id: any) => {
  return Http.delete(`cuisine/${id}`);
};
export const getUpdateCuisenStatusAPI = (id:any,data: any) => {
  return Http.put(`cuisine/status/${id}`, data);
};
